import html2canvas from 'html2canvas';

/**
 * Generate ticket as image (PNG/JPEG)
 * @param {HTMLElement} ticketElement - The ticket DOM element
 * @param {string} format - Image format ('png' or 'jpeg')
 * @param {number} quality - Image quality (0-1, for JPEG)
 * @returns {Promise<string>} Data URL of the ticket image
 */
export const generateTicketImage = async (
  ticketElement,
  format = 'png',
  quality = 0.92,
  scale = 2
) => {
  try {
    const canvas = await html2canvas(ticketElement, {
      backgroundColor: '#FFFFFF',
      scale,
      logging: false,
      useCORS: true,
      allowTaint: false
    });

    return canvas.toDataURL(`image/${format}`, quality);
  } catch (error) {
    console.error('Error generating ticket image:', error);
    throw error;
  }
};

/**
 * Download ticket as image
 * @param {string} dataUrl - Data URL of the ticket image
 * @param {string} ticketId - Ticket ID for filename
 * @param {string} format - Image format ('png' or 'jpeg')
 */
export const downloadTicketImage = (dataUrl, ticketId, format = 'png') => {
  const link = document.createElement('a');
  link.download = `ticket-${ticketId}.${format}`;
  link.href = dataUrl;
  link.click();
};

/**
 * Convert data URL to blob for email attachments
 * @param {string} dataUrl - Data URL of the image
 * @returns {Blob} Blob object
 */
export const dataURLtoBlob = (dataUrl) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

